import api from '@/store/api'
import * as OpenCC from 'opencc-js'
var All = {
  methods: {
    // sentenceSpliter (text) {
    //   const pattern = /\p{L}[\p{L}\p{N}]*(?:['’\-][\p{L}\p{N}]+)*|\p{N}+|[^\p{L}\p{N}'’\-\s]|\s+/gu
    //   return text.match(pattern) || []
    // },
    getTTSUrl (gender, result) {
      const path = '/ai/generate/tts'

      const body = {
        text: result,
        lang: this.$store.state.selectedAccent
      }
      const nameCode = this.name_code || this.$route.query.name_code
      if (nameCode) {
        body.name_code = nameCode
      } else {
        body.kid = false
        body.gender = gender || 'female'
      }

      const options = { headers: { showLoading: false } }
      return api.post(path, body, options)
        .then((res) => {
          return res.data.url
        })
        .catch((err) => {
          console.error(err)
        })
    },
    get_Translate_Dialog (theme, context, result) {
      // let self = this
      // 會話翻譯

      const path = '/ai/generate/translate/dialog'

      const converter = OpenCC.Converter({ from: 'cn', to: 'tw' })
      const options = { headers: { showLoading: false } }
      return api.post(path, {
        content: result,
        theme: theme,
        context: context
      }, options)
        .then((res) => {
          return converter(res.data.result)
        })
        .catch(() => {
        })
    },
    playAudioStandard (dynamicId) {
      const self = this

      if (self.$refs[`playBtn${dynamicId}`]) {
        const audioPlayer = self.$refs[`playBtn${dynamicId}`]

        audioPlayer.onplaying = () => {
          self.isPlaying = true
        }
        audioPlayer.onpause = () => {
          self.isPlaying = false
        }
        // 播放切換
        if (self.isPlaying) {
          audioPlayer.pause()
          audioPlayer.currentTime = 0
          self.isPlaying = false
        } else {
          audioPlayer.play()
          self.isPlaying = true
        }
      }
    },
    copy_text_selection (text) {
      navigator.clipboard.writeText(text)
    },
    getSTT (audioData) {
      const path = `/ai/ers?lang=${this.$store.state.selectedAccent}`

      return api.post(path, audioData, {
        headers: {
          'Content-Type': audioData.type || 'audio/wav',
          showLoading: false
        }
      })
        .then((response) => {
        // this.$store.dispatch('getRemainPoints')
          return response.data
        })
        .catch((error) => {
          console.error('ERS API Error:', error)
          throw error
        })
        .finally(() => {
        // this.isRecognition = false
        })
    }

  }
}

export default All
